//@ts-check
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import createBatchAction from '@/common/lib/create-batch-action';
import { STATUS_FAILURE_IDPASSWORD, STATUS_FAILURE_NOT_AUTHORIZED, STATUS_FAILURE_NO_USER } from '@/common/constants';
import { initEntity } from '@/common/lib/entity-module';

export const loginRequest = createBatchAction('@@login/LOGIN_REQUEST', () => [showLoading()]);
export const loginSuccess = createBatchAction('@@login/LOGIN_SUCCESS', (res) => [
  hideLoading(),
  initEntity({ target: 'up', data: res.up }),
  initEntity({ target: 'errMsgLogin', data: '' })
]);
export const loginFailure = createBatchAction('@@login/LOGIN_FAILURE', (err) => [
  hideLoading(),
  createNgHandler(err),
]);

const createNgHandler = (e) => {
  switch (e?.status) {
    case STATUS_FAILURE_NOT_AUTHORIZED:
    case STATUS_FAILURE_IDPASSWORD:
      return initEntity({ target: 'errMsgLogin', data: '電話番号またはパスワードが間違っています' });
    case STATUS_FAILURE_NO_USER:
      return initEntity({ target: 'errMsgLogin', data: '電話番号の登録がありません' });
    default:
      return initEntity({ target: 'errMsgLogin', data: 'ログインに失敗しました' });
  }
};